import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconEnergyConsumption: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 24 24">
    <path
      d="M16.061 3.09045L16.4853 3.51472C17.5996 4.62902 18.4835 5.95189 19.0865 7.4078C19.6896 8.86371 20 10.4241 20 12C20 13.5759 19.6896 15.1363 19.0865 16.5922C18.4835 18.0481 17.5996 19.371 16.4853 20.4853L16.061 20.9095L14.1515 19L15 18.1515L16.0492 19.2007C16.8593 18.2951 17.5118 17.2582 17.9779 16.133C18.444 15.0078 18.7158 13.8132 18.7833 12.6H16.4V11.4H18.7833C18.7158 10.1868 18.444 8.99223 17.9779 7.86702C17.5118 6.7418 16.8593 5.70488 16.0492 4.7993L15 5.84852L14.1514 4.99999L15.5757 3.57573L15.5772 3.57422L16.061 3.09045Z"
      fillOpacity="0.878431"
    />
    <path
      d="M8.03151 9.12518L6.16148 11.4627C5.79481 11.921 6.12114 12.6 6.70809 12.6H8.25165L7.03151 14.1252L7.96855 14.8748L9.83857 12.5373C10.2052 12.079 9.87892 11.4 9.29196 11.4H7.7484L8.96855 9.87482L8.03151 9.12518Z"
      fillOpacity="0.878431"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 12C13 12.6197 12.8872 13.2132 12.6811 13.7608L14.84 15.38L14.12 16.34L12.1172 14.8379C11.2151 16.1441 9.70752 17 8 17C5.23858 17 3 14.7614 3 12C3 9.23858 5.23858 7 8 7C10.7614 7 13 9.23858 13 12ZM11.8 12C11.8 14.0987 10.0987 15.8 8 15.8C5.90132 15.8 4.2 14.0987 4.2 12C4.2 9.90132 5.90132 8.2 8 8.2C10.0987 8.2 11.8 9.90132 11.8 12Z"
      fillOpacity="0.878431"
    />
  </Icon>
);
